import React from 'react';
import { render } from 'react-dom';
import RenderView from './RenderSet/RenderView';
import { EventEmitter } from 'fbemitter';

class Render extends EventEmitter {
    constructor({ target = '', data = {}, theme }) {
        super();
        this.renderTarget = target;
        this.renderData = data;
        this.theme = theme;
    }

    get renderData() {
        return this._data;
    }

    set renderData(data) {
        this._data = data;
        this.render();
    }

    set titleIndex(index) {
        const content = Object.assign({}, this._data.content, {
            titleIndex: index,
        });
        this.renderData = Object.assign({}, this._data, { content });
    }

    set contentIndex(index) {
        const content = Object.assign({}, this._data.content, {
            contentIndex: index,
        });
        this.renderData = Object.assign({}, this._data, { content });
    }

    replaceContent(reg, value) {
        const content = Object.assign({}, this._data.content, {
            content: this._data.content.content.replace(reg, value),
        });
        this.renderData = Object.assign({}, this._data, { content });
    }

    get renderTarget() {
        return this._target;
    }

    set renderTarget(target) {
        if (this._target) {
            return;
        }
        if (typeof target === 'string') {
            this._target = $(target)[0];
        } else if (target instanceof $) {
            this._target = target[0];
        } else if (target instanceof Element) {
            this._target = target;
        }
    }

    render() {
        render(
            <RenderView item={this._data} emitter={this} theme={this.theme} />,
            this._target
        );
    }

    on(eventType, callback) {
        this.addListener(eventType, callback);
        return this;
    }

    one(eventType, callback) {
        this.once(eventType, callback);
        return this;
    }

    off(eventType) {
        this.removeAllListeners(eventType);
        return this;
    }
}

export default Render;



// WEBPACK FOOTER //
// ./components/Render.js